<div class="step-progress">
    <div *ngFor="let step of steps; let i = index" class="step">
      @if (cierreDiarioService.loading()) {
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
      } @else {
        <button [disabled]="deshabilitarEtapa(i)" (click)="cambiarEtapa(i)" class="step-square d-flex justify-content-center align-items-center" [ngClass]="{'bg-success': step.completed, 'bg-primary': i === currentStepIndex}">
          {{ i + 1 }}
        </button>
      }
      <div class="step-label mt-2 text-center">{{ step.label }}</div>
    </div>
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width]="progressWidth"></div>
    </div>
</div>
  